import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


export default function Error404() {
    const { t } = useTranslation();

    return (
        <div className="ecp-container">
            <div className="ecp-container-content-error">
                <div className="error-container">
                    <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                    <div className="error-container-text">
                    <h1 className="page-title">
                        {t("Service non actif")}
                    </h1>
                    <p className="page-link_home">
                        <Link to="/"> {t("Revenir à l'accueil")}</Link>
                    </p>
                    </div>
                </div>
            </div>
        </div>
    )
}